import { RenderersUIType } from "@home-health-notify/domain";
import {
  and,
  RankedTester,
  rankWith,
  schemaTypeIs,
  uiTypeIs,
} from "@jsonforms/core";

export const appointmentPickerTester: RankedTester = rankWith(
  5,
  and(uiTypeIs(RenderersUIType.AppointmentPicker), schemaTypeIs("object")),
);
